import api from './api';

class ClienteService {
  /**
   * Criar novo cliente
   */
  async criar(clienteData) {
    const response = await api.post('/clientes', clienteData);
    return response.data;
  }

  /**
   * Listar clientes com paginação e filtros
   */
  async listar(filtros = {}) {
    const params = new URLSearchParams();
    
    if (filtros.page) params.append('page', filtros.page);
    if (filtros.pageSize) params.append('pageSize', filtros.pageSize);
    if (filtros.nome) params.append('nome', filtros.nome);
    if (filtros.cnpj) params.append('cnpj', filtros.cnpj);

    const response = await api.get(`/clientes?${params.toString()}`);
    return response.data;
  }

  /**
   * Listar todos os clientes (sem paginação)
   */
  async listarTodos() {
    const response = await api.get('/clientes/todos');
    return response.data;
  }

  /**
   * Buscar cliente por ID
   */
  async buscarPorId(id) {
    const response = await api.get(`/clientes/${id}`);
    return response.data;
  }

  /**
   * Buscar cliente por CNPJ
   */
  async buscarPorCnpj(cnpj) {
    const response = await api.get(`/clientes/cnpj/${cnpj}`);
    return response.data;
  }

  /**
   * Atualizar cliente
   */
  async atualizar(id, clienteData) {
    const response = await api.put(`/clientes/${id}`, clienteData);
    return response.data;
  }

  /**
   * Excluir cliente
   */
  async excluir(id) {
    const response = await api.delete(`/clientes/${id}`);
    return response.data;
  }
}

const clienteService = new ClienteService();
export default clienteService;
